import React, { useState } from "react"
import { TextField } from "@material-ui/core"
import JsonEditorModal from "../Administration/TextTypes/Forms/JsonEditor"

function Field({ formik, name, type, value = null, error = null, small = false,...rest }) {
  const [modalOpen, setModalOpen] = useState(false)
  const rawValue = value ?? formik?.values[name]
  const stringValue = typeof rawValue === "object" ? JSON.stringify(rawValue) : rawValue

  const handleSave = (json) => {
    formik.setFieldValue(name, json)
  }

  const openEditorIfArray = () => {
    if (type === "json") {
      setModalOpen(true)
    }
  }
  return ( <>
    <TextField
      fullWidth
      style={{ width: small && "70px" }} 
      name={name && name}
      type={type ? type : "text"}
      {...rest}
      variant="outlined"
      onClick={openEditorIfArray}
      value={stringValue}
      onChange={formik?.handleChange}
      error={error || (formik?.touched[name] && Boolean(formik?.errors[name]))}
      helperText={error || (formik?.touched[name] && formik?.errors[name])}
    />
     {type === "json" && (
        <JsonEditorModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          value={formik?.values[name] || {}}
          onSave={handleSave}
          title={rest.label}
        />
      )}
      </>
  )
}

export default Field
